import ParagraphLeftIcon from "../images/ParagraphLeftIcon.mjs";

/**
 * Simulation status: info collection
 * @see {GlyphIcon}
 * @see {ParagraphLeftIcon}
 */
const AppSimStatusInfoIcon = class extends ParagraphLeftIcon {};

export default AppSimStatusInfoIcon;